import React, { useState } from 'react';
import { Application } from '../../../../../../entities/Application';
import { getLabelForCount } from '../../../../../../utils/grammar';
import { CloseButton } from './CloseButton';
import { TabHeaders } from './TabHeaders';
import { ApplicationActions } from './ApplicationActions';
import { ApplicationQuestions } from '../ApplicationQuestions';
import { Resume } from '../Resume';
import { AlertObject } from '../../../../../../components/Alert';
import { BULK_REVIEW_NAVIGATION_TYPE } from '../../..';
import styles from '../../styles.module.scss';
import classNames from 'classnames';
import { RedactingLoadingState } from '../../../../RedactingLoadingState';
import { NavigationButtons } from './NavigationButtons';

export type BULK_REVIEW_TABS = 'resume' | 'questions';

interface PropTypes {
  application: Application;
  index: number;
  isLoadingResume: boolean;
  preSelectedRejectReasonId: number;
  totalApplications: number;
  isActionsDisabled: boolean;
  resumeUrl?: string;
  onNext: (navType: BULK_REVIEW_NAVIGATION_TYPE) => void;
  onPrevious: () => void;
  onClose: () => void;
  onConflict: () => void;
  setAlert: (alert: AlertObject) => void;
  setPreSelectedRejectReasonId: (id: number) => void;
}

function Content(props: {
  activeTab: BULK_REVIEW_TABS;
  application: Application;
  isLoadingResume: boolean;
  resumeUrl?: string;
}) {
  if (props.resumeUrl == null && props.isLoadingResume) {
    return <RedactingLoadingState redacted={props.application.redacted} />;
  }

  return (
    <div className={classNames('flex-grow-1', styles['hidden-scrollbar'])}>
      {props.activeTab === 'resume' ? (
        <Resume
          loadingElement={
            <RedactingLoadingState redacted={props.application.redacted} />
          }
          url={props.resumeUrl}
        />
      ) : (
        <ApplicationQuestions application={props.application} />
      )}
    </div>
  );
}

function getCurrentIndex(index: number, totalApplications: number) {
  const currentIndex = index + 1;

  if (currentIndex > totalApplications) {
    return totalApplications;
  }

  return currentIndex;
}

export function BulkApplicationReviewHeader(props: PropTypes) {
  const [activeTab, setActiveTab] = useState<BULK_REVIEW_TABS>('resume');

  return (
    <>
      <div className='border-bottom px-4 mt-4'>
        <CloseButton onClose={props.onClose} />
        <div className='fs-5 text-dark-200 flex-shrink-0'>
          Reviewing {getCurrentIndex(props.index, props.totalApplications)} out
          of {getLabelForCount('Candidate', props.totalApplications)}
        </div>
        <div className='d-flex mt-4 justify-content-between align-items-center'>
          <NavigationButtons
            index={props.index}
            onPrevious={props.onPrevious}
            onNext={props.onNext}
          />
          <ApplicationActions {...props} />
        </div>
        <TabHeaders activeTab={activeTab} onTabChange={setActiveTab} />
      </div>
      <Content
        activeTab={activeTab}
        application={props.application}
        resumeUrl={props.resumeUrl}
        isLoadingResume={props.isLoadingResume}
      />
    </>
  );
}
